import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Designing Data-Intensive Applications by Martin Kleppmann"
        desc="The big ideas behind reliable, scalable, and maintainable systems"
        keyword="designing data-intensive applications, martin kleppmann, distributed systems, databases, DDIA"
        image="/images/books/designing-data-intensive-applications.jpg"
        pageType="book"
        author="Martin Kleppmann"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/designing-data-intensive-applications.jpg"
                alt="designing data-intensive applications martin kleppmann engineering book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Designing Data-Intensive Applications
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Martin Kleppmann</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Martin Kleppmann takes readers on a deep tour of the principles and trade-offs
                behind the systems that store, process, and deliver data at scale. Covering
                everything from database internals and replication strategies to stream processing
                and batch computation, DDIA gives engineers the conceptual tools to make informed
                decisions about the data infrastructure they build and depend on.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Often called the "bible of distributed systems," this book stands out for its
                clarity and depth. Kleppmann doesn't just describe how tools work — he explains
                why they were designed that way and where they break down. Whether you're choosing
                between databases, designing a data pipeline, or reasoning about consistency
                guarantees, this is the book you'll keep coming back to.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
